<template>

    <div class="scroll-post__title">
      <!-- <div class="scroll-post__horizontal-line scroll-post__horizontal-line--top"></div> -->
      <transition name="slide-fade">
      <h2 v-if="showSlideShow" class="scroll-post__page-title" :style="getTitleStyle(slides[0])">{{ frontSlide.title }}</h2>
      </transition>

      <transition name="opacity">
      <div v-if="!hideTitle">
        <transition-group name="group" tag="div">
          <HeroTitleSingle v-for="slide in slides" :key="slide.id" :style="getHeaderStyle(slide)" :slide="slide" :show-slide-show="showSlideShow"/>
        </transition-group>
      </div>
      </transition>
      <transition name="slide-fade">
        <div class="scroll-post__horizontal-line" v-if="showSlideShow">
          <div class="scroll-post__horizontal-line scroll-post__horizontal-line--loading" v-if="showSlideShow && autoplayLoading > -1" :style="{width: autoplayLoading + '%' }"></div>
        </div>
      </transition>

    </div>
</template>

<script>
  import HeroTitleSingle from './HeroTitleSingle.vue';
  export default {
    components: {
      HeroTitleSingle,
    },
    props: ['slides', 'getPercent', 'showSlideShow', 'autoplayLoading', 'frontSlide'],
    computed: {
      hideTitle() {
        return this.$store.state.hero.hideTitle;
      }
    },
    data () {
      return {
        showBack: rtwp.show_back,
      }
    },
    methods: {
      getHeaderStyle(slide) {
        const step = 260;
        const {relativePositionFloat} = this.getPercent(slide);
        const top = (relativePositionFloat) * step;
        const opacity = 1 - 1.5 * Math.pow(relativePositionFloat, 2);
        const display = opacity <= 0 ? 'none' : undefined;
        return {
          opacity,
          display,
          bottom: -top + 'px',
        };
      },
      getTitleStyle(slide) {
        const step = 260;
        const {relativePositionFloat} = this.getPercent(slide);
        const top = relativePositionFloat <= 1 && relativePositionFloat >= -1 ?
            (relativePositionFloat + (relativePositionFloat < 0 ? 1 : -1 ))* step : 0;
        const opacity = 1.5 * Math.pow(relativePositionFloat, 2);
        const display = opacity <= 0 ? 'none' : undefined;
        return {
          opacity,
          display,
          top: top + 'px',
        };
      },

    },
  };
</script>

